<template>
  <main class="container my-5">
    <div class="container text-center px-3 px-lg-5">
      <img
        class="w-25 mt-5 mb-3"
        style="max-width: 140px;"
        src="https://pagglo-cdn.s3.amazonaws.com/app/assets/bid.png"
        alt=""
      />
      <h3>R$ {{ formatPrice(pagamento.valor) }}</h3>
      <h6 class="m-4">{{ pedido.redeLoja ? pedido.redeLoja.nome : '' }}</h6>
      <span class="d-block m-2 text-bold text-muted">Método de pagamento:</span>
      <span class="d-block m-2 text-bold">{{ metodoPagamentoString }}</span>

      <div v-if="parcelamentoPermitido">
        <span class="d-block m-2 text-bold text-muted">
          Quantidade de parcelas:
          <select
            class="form-control"
            v-model="quantidadeParcelasSelecionado"
            @change="recalcularPedido"
          >
            <option
              v-for="(opcaoParcelamento, index) in opcoesParcelamento"
              :key="index"
              :value="opcaoParcelamento.quantidade"
            >
              {{ opcaoParcelamento.descricao }}
            </option>
          </select>
        </span>
      </div>

      <span class="d-block m-2 text-bold text-muted" v-if="btnLoading">
        Processando seu pagamento
        <span class="spinner-border grey ml-2"></span>
      </span>
    </div>
    <div
      class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between"
    >
      <button
        class="btn btn-secondary px-lg-5 mt-4 py-2"
        @click="goToStep('pagamento')"
        :disabled="btnLoading"
      >
        VOLTAR
      </button>
      <button
        class="btn btn_color_system py-2 px-lg-5 mt-4"
        @click="processarPagamento()"
        :disabled="btnLoading"
      >
        Confirmar Pagamento
        <span class="spinner-border grey ml-2" v-if="btnLoading"></span>
      </button>
    </div>
    <div
      class="px-4 my-4 alert alert-danger"
      role="alert"
      v-if="!btnLoading && erroPagamento"
    >
      {{ mensagemErroPagamento }}
    </div>
  </main>
</template>

<script>
import { APIService } from '../../APIService'
const apiService = new APIService()

export default {
  name: 'StepPagamento',
  components: {},
  props: ['confirmacaoPagamento', 'objPedido'],

  data() {
    return {
      URL_SLUG: window.URL_SLUG,
      cartao: {},
      pagamento: {},
      pedido: {},
      carteira: {},
      cartoes: [],
      btnLoading: false,
      metodoPagamentoString: null,
      quantidadeMaximaParcelasParaValor: 0,
      opcoesParcelamento: [],
      quantidadeParcelasSelecionado: 1,
      erroPagamento: false,
      mensagemErroPagamento: null,
      parcelamentoPermitido: false,
    }
  },
  mounted() {
    this.carrinho = {
      id: this.confirmacaoPagamento.carrinhoId,
    }
    this.pedido = {
      redeLoja: {
        codigoLoja: this.confirmacaoPagamento.codigoLoja,
        nome: this.confirmacaoPagamento.nomeLoja,
      },
    }
    this.pagamento = {
      valor: this.confirmacaoPagamento.valor,
      metodo: this.confirmacaoPagamento.metodo,
      codigoCartao: this.confirmacaoPagamento.codigoCartao,
      labelCartao: this.confirmacaoPagamento.labelCartao,
    }
    this.cartao = {
      bandeira: this.confirmacaoPagamento.cartaoBandeira,
      ultimosDigitos: this.confirmacaoPagamento.cartaoUltimosDigitos,
    }

    if (this.pagamento.metodo == 'SALDO_CARTEIRA') {
      this.metodoPagamentoString = 'Saldo em carteira'
      this.parcelamentoPermitido = false
    }
    if (this.pagamento.metodo == 'SALDO_CARTEIRA_CASHBACK') {
      this.metodoPagamentoString = 'Saldo em carteira +  cashback'
      this.parcelamentoPermitido = false
    }
    if (this.pagamento.metodo == 'CARTAO_CREDITO') {
      this.metodoPagamentoString =
        this.cartao.bandeira +
        ' **** **** **** ' +
        this.cartao.ultimosDigitos.replace('(não verificado)', '')
      this.parcelamentoPermitido = true
    }

    if (this.parcelamentoPermitido) {
      apiService
        .simularParcelamentoCompra(this.objPedido.pedidoDTO)
        .then((res) => {
          this.opcoesParcelamento = res
        })
        .catch(() => {
          this.parcelamentoPermitido = false
        })
    }
  },
  methods: {
    processarPagamento() {
      if (!this.btnLoading) {
        this.btnLoading = true

        if (this.pagamento.metodo == 'CARTAO_CREDITO') {
          this.pagamento.quantidadeParcelas = this.quantidadeParcelasSelecionado
        }

        const pagamentoDTO = {
          codigoLoja: this.pedido.redeLoja.codigoLoja,
          metodo: this.pagamento.metodo,
          nomeLoja: this.pedido.redeLoja.nome,
          codigoCartao: this.pagamento.codigoCartao ?? '',
          valor: +this.pagamento.valor,
          quantidadeParcelas: this.pagamento.quantidadeParcelas ?? 1,
        }
        apiService
          .checkoutPagamento(this.confirmacaoPagamento.carrinhoId, pagamentoDTO)
          .then(() => {
            this.erroPagamento = false
            localStorage.removeItem('codigoLoja')
            localStorage.removeItem('carrinho')
            localStorage.removeItem('idCarrinho')
            this.$store.dispatch('limparPedido')

            this.$swal({
              title: 'Pagamento realizado com sucesso ',
            }).then(() => {
              this.$store.dispatch('limparPedido')
              this.$router.push(
                `/pedidos/${this.confirmacaoPagamento.carrinhoId}`,
              )
            })
          })
          .catch((error) => {
            this.btnLoading = false
            this.erroPagamento = true
            this.mensagemErroPagamento = error.response.data.title
          })
      }
    },
    recalcularPedido() {
      apiService
        .recalcularCompra(
          this.quantidadeParcelasSelecionado,
          this.objPedido.pedidoDTO,
        )
        .then((res) => {
          this.erroPagamento = false
          this.objPedido.pedidoDTO = res
          this.pagamento.valor = this.objPedido.pedidoDTO.valorTotal
        })
        .catch((error) => {
          this.btnLoading = false
          this.erroPagamento = true
          this.mensagemErroPagamento = error.response.data.title
        })
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    goToStep(step) {
      this.$emit('goToStep', step)
    },
  },
}
</script>
<style scoped lang="scss"></style>
